import { render, staticRenderFns } from "./EmployeeSelector.vue?vue&type=template&id=48b4760d&"
import script from "./EmployeeSelector.vue?vue&type=script&lang=js&"
export * from "./EmployeeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports